import styled, { css } from 'styled-components/macro'
import { media } from 'styles/mixins'
import { h4, body1, body2, overline, subtitle1 } from 'styles/mixins/textstyles'

export const PanelPadding = styled.div`
  padding: 3.2rem 4rem;
  // text-align: ${(props) => (props.align ? props.align : 'inherit')};

  ${media.mobile`
    padding: 2.4rem;

    ${(props) =>
      props.noPadding &&
      css`
        padding: 0;
      `}
  `}

  ${(props) =>
    props.noPadding &&
    css`
      padding: 0;
    `}
`

const Panel = styled.section`
  transform: translateZ(-100px); // Force hardware acceleration in safari to fix render bug
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 5px;
  padding: 2.4rem 4rem;
  text-align: ${(props) => (props.left ? 'left' : 'center')};
  width: 100%;

  ${(props) =>
    props.noPadding &&
    css`
      padding: 0;
    `}

  ${(props) =>
    props.bottomBorderOnly &&
    css`
      border-radius: 5px 5px 0 0;
      border-top: none;
      border-right: none;
      border-left: none;
    `}

  ${media.mobile`
    width: 100%;
    border-radius: 0;
    border-right: none;
    border-left: none;
    padding: 2.4rem;

    ${(props) =>
      props.noPadding &&
      css`
        padding: 0;
      `}
  `}

  > p:not([class]) {
    color: ${(props) => props.theme.colors.greyDarker};
  }
`

export const PanelText = styled.p`
  ${(props) => body2(props.theme.colors.black, 'medium')}

  margin: 1.6rem 4.8rem;
`

export const UnderPanelText = styled.p`
  ${(props) => body1(props.theme.colors.black, 'medium')}

  text-align: center;
  padding: 1rem 0;
`

export const PanelSpacer = styled.div`
  margin: 0;
  padding: 0;
  height: 2.4rem;
`

export const PanelTitle = styled.h3`
  ${overline()}

  color: ${(props) => props.color};
  padding: 1rem 0;

  ${media.mobile`
    padding-left: ${(props) => props.paddingLeft || '1rem'};

    &:first-child {
      padding-top: 1.6rem;
    }
  `}
`

export const PanelHeading = styled.h1`
  ${(props) => h4(props.theme.colors.black)}
  margin-bottom: .8rem;
`

export const PanelSubheading = styled.p`
  ${(props) => subtitle1(props.theme.colors.black)}
  margin-bottom: .8rem;
`

export default Panel
